import { useMutation } from '@tanstack/react-query';
import { ProjectsAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

export const projectsAPI = new ProjectsAPI(axios);

export const useProjectsBatchPublishMutation = () =>
    useMutation({
        mutationFn: async () => {
            const projects = await projectsAPI.getProjects();
            return Promise.all(
                projects.map(async (project) =>
                    projectsAPI.publishProject(project.id, {
                        version: project.version ?? '',
                        description: project.idn,
                        type: 'public'
                    })
                )
            );
        }
    });
